
<template>

<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="普通线索" name="first" :lazy="true">
        <clue-management ref="clue-management"></clue-management>
    </el-tab-pane>
<!--    <el-tab-pane  v-if="isAdmin"  label="一成购线索" name="second">-->
<!--        <clue-oneBuyCar ref="clue-oneBuyCar" :lazy="true"></clue-oneBuyCar>-->
<!--    </el-tab-pane>-->
<!--    <el-tab-pane v-if="isAdmin" label="团购惠线索" name="three">-->
<!--        <clue-group-purchase ref="clue-group-purchase" :lazy="true"></clue-group-purchase>-->
<!--    </el-tab-pane>-->
<!--    <el-tab-pane v-if="isAdmin" label="推荐线索" name="five">-->
<!--        <lcw-clue-management ref="clue-group-purchase" :lazy="true"></lcw-clue-management>-->
<!--    </el-tab-pane>-->
    <el-tab-pane label="商品线索" name="six">
        <plus-clue ref="plus-clue"></plus-clue>
    </el-tab-pane>
</el-tabs>

</template>

<script>

import BasicPager from '@/mixins/BasicPager'
import clueManagement from './clueManagement'
import clueOneBuyCar from './clueOneBuyCar'
import clueGroupPurchase from './clueGroupPurchase'
import lcwClueManagement from './lcwClueManagement'
import plusClue from './plusClue'
export default {
  name: 'clue-tab-index',
  extends: BasicPager,
  data () {
    return {
      isAdmin: false,
      activeName: 'first'
    }
  },
  mounted: function () {
    let userInfo = JSON.parse(localStorage.userInfo)
    this.isAdmin = userInfo.loginPath !== 'channel'
    this.$refs['clue-management'].loadList(1)
  },
  components: {
    clueManagement,
    clueOneBuyCar,
    clueGroupPurchase,
    lcwClueManagement,
    plusClue
  },
  methods: {
    handleClick (tab, event) {
      let that = this
      switch (tab.index) {
        case '0':
          that.$refs['clue-management'].loadList(1)
          break
        case '1':

          break
        default:
      }
    }
  }
}

</script>
